module.exports = __webpack_public_path__ + "img/组 352.28c58728.png";